<template>
    <div>
        <Row :gutter="10" style="margin-bottom: 8px">
            <Col>
                <DatePicker type="daterange" v-model="filter_pickUpDate" placeholder="Pickup Date"
                            :clearable="false" format="dd/MM/yyyy" style="width: 264px" @on-change="onChangeDate"></DatePicker>
            </Col>
            <Col span="5" offset="7" style=" margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: dealerCityFilter}"
                             :debounce="500" :skip="skip.dealerSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Order City" v-model="dealerCity" :clearable="true" element-id="client_city"
                                          @on-clear="onClearCity('clientCity')" @on-search="onSearchCity($event, 'clientCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'clientCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="5" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                             :debounce="500" :skip="skip.pickupSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true" element-id="pickup_city"
                                          @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="5" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                             :debounce="500" :skip="skip.dropSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true" element-id="drop_city"
                                          @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="2" style="margin-top: -31px;">
                <Button @click="startAddingOrder">Add Order</Button>
            </Col>
        </Row>
        <Row>

                <Table :columns="headers" :data="orders" @on-row-click="editOrder" stripe
                       :loading="$apollo.queries.orders.loading" size="small" @on-selection-change="onSelectionChangeOrder">
                    <template slot-scope="{ row }" slot="lrName">
                        <span>{{row.orderDetails&&row.orderDetails.lrObject&&row.orderDetails.lrObject.hasOwnProperty('lrName')?row.orderDetails.lrObject.lrName:'-'}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="pickupDate">
                        <span>{{formatDate(row.pickupDate)}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="orderNumber">
                        <span>{{row.orderNumber}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="dealerName">
                        <span @click.stop="openCompanyDetail(row.clientobject.id)">
                                {{row.clientobject.name}}<br>({{row.clientobject.address[0].city}})</span>
                    </template>
                    <template slot-scope="{ row }" slot="dealerMobile">
                        <span>{{row.clientobject.mobile}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="originalPickupParty">
                        <span v-if="row.pickuppartyobject">
                            {{row.pickuppartyobject.name}}<br>({{row.pickuppartyobject.address[0].city}})</span>
                        <span v-else>-</span>
                    </template>
                    <template slot-scope="{ row }" slot="newPickupParty">
                        <span v-if="row.orderDetails&&row.orderDetails.pickupPoint&&row.orderDetails.pickupPoint.pickupPartyId">
                            {{row.orderDetails.pickupPoint.pickupPartyName}}<br>({{row.orderDetails.pickupPoint.city}})</span>
                        <span v-else>-</span>
                    </template>
                    <template slot-scope="{ row }" slot="newPickupParty_Mobile">
                        <span v-if="row.orderDetails&&row.orderDetails.pickupPoint&&row.orderDetails.pickupPoint.pickupPartyId">
                            {{row.orderDetails.pickupPoint.mobile}}</span>
                        <span v-else>-</span>
                    </template>
                    <template slot-scope="{ row }" slot="internalStatus">
                        <span style="text-transform: capitalize">{{row.internalStatus.name}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="size">
                        <span style="text-transform: capitalize">{{row.materials.boxes}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="weight">
                        <span style="text-transform: capitalize">{{row.materials.kg}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="tempo_platNo">
                        <template v-if="row.orderDetails&&row.orderDetails.PIckupTempo">{{row.orderDetails.PIckupTempo.tempo.platNo}}</template>
                        <template v-else-if="row.orderDetails&&row.orderDetails.PickupTruck">{{row.orderDetails.PickupTruck.truck.platNo}}</template>
                        <template v-else>-</template>
                    </template>
                    <template slot-scope="{ row }" slot="tempo_contractor">
                        <template v-if="row.orderDetails&&row.orderDetails.PIckupTempo">
                            {{row.orderDetails.PIckupTempo.contractor.name}}<br/>
                            {{row.orderDetails.PIckupTempo.contractor.mobile}}</template>
                        <template v-else-if="row.orderDetails&&row.orderDetails.PickupTruck">
                            {{row.orderDetails.PickupTruck.Transporter.name}}<br/>
                            {{row.orderDetails.PickupTruck.Transporter.mobile}}
                        </template>
                        <template v-else>-</template>
                    </template>
                    <template slot-scope="{ row }" slot="truck_platNo">
                        <template v-if="row.orderDetails&&row.orderDetails.truckOrder">{{row.orderDetails.truckOrder.truck.platNo}}</template>
                        <template v-else>-</template>
                    </template>
                    <template slot-scope="{ row }" slot="truck_transporter">
                        <template v-if="row.orderDetails&&row.orderDetails.truckOrder&&row.orderDetails.truckOrder.Transporter">
                            {{row.orderDetails.truckOrder.Transporter.name}}<br/>
                            {{row.orderDetails.truckOrder.Transporter.mobile}}
                        </template>
                        <template v-else>-</template>
                    </template>
                    <template slot-scope="{ row }" slot="note">
                        <span style="text-transform: capitalize">{{row.note}}</span>
                    </template>
                    <!--<template slot-scope="{ row }" slot="droppingParty">-->
                        <!--<span v-if="row.droppingpartyobject">-->
                            <!--{{row.droppingpartyobject.name}}<br>({{row.droppingpartyobject.address[0].city}})</span>-->
                        <!--<span v-else>-</span>-->
                    <!--</template>-->

                </Table>

        </Row>

        <place-order-drawer ref="place-order-form"></place-order-drawer>
        <company-detail ref="company-detail-page"></company-detail>

    <!--
        <Drawer :mask-closable="true" class="demo-drawer-prime"
                title="Order Detail" v-model="orderDetailDrawer" width="720">
        <order-detail :orderId="orderId" ref="order-detail-page"></order-detail>
        </Drawer>
                    -->

        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
    </div>
</template>

<script>
import PlaceOrderDrawer from './PlaceOrderDrawer'
import CompanyDetail from './CompanyDetail'
import { SEARCH_CITY2 } from '../graphql/queries/territories'
import {FILTER_ALL_ORDERS} from '../graphql/queries/Orders'
import {SUBSCRIBE_ALL_ORDERS} from '../graphql/subscription/Orders'
import OrderDetail from './OrderDetail'
import ManageOrder from './Manage Order/ManageOrder'
import moment from 'moment'

export default {
    apollo: {
        orders: {
            query: FILTER_ALL_ORDERS,
            subscribeToMore: {
                document: SUBSCRIBE_ALL_ORDERS,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter,
                        lrName: this.lrName,
                    }
                },
                updateQuery: function(previousResult, { subscriptionData }) {
                    this.orders = subscriptionData.data.orders;
                },
            },
            variables() {
                return {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    clientCity: this.selectedDealerCity,
                    pickupCity: this.selectedPickupCity,
                    dropCity: this.selectedDroppingCity,
                    searchFilter: this.searchFilter,
                    lrName: this.lrName,
                }
            },
            result ({ data, loading }) {
                if (!loading) {
                    this.orders = data.orders;
                }
            }
        }
    },
        name: 'Orders',
        props:['globalSearch'],
        components: {OrderDetail, PlaceOrderDrawer, CompanyDetail, ManageOrder},
        provide() {
          return {
            getManageOrderDrawer: () => this.manageOrderDrawer,
            setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
            getOrder: () => this.order,
            closeAssignVehicleDialog: (data) => { },
          }
        },
        data() {
            return {
                query_SEARCH_CITY: SEARCH_CITY2,
                placeOrderDrawer: false,
                orderDetailDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                orders: [],
                headers: [
                    {type: 'selection', width: 60, align: 'center'},
                    {title: 'Pickup date', slot: 'pickupDate', width:125,
                        renderHeader: function (h) {return h('div', [h('p', 'Pickup'), h('p', 'Date')])}},
                    {title: 'LR No.', slot: 'lrName',width:125, className: "table-orderNum-column"},
                    {title: 'ERP Order No', slot: 'orderNumber', width:165, className: "table-orderNum-column"},
                    {title: 'Software Order Status', slot: 'internalStatus', width:165, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Software'), h('p', 'Order Status')])}},
                    {title: 'Client Name', slot: 'dealerName', width:165, className: "table-dealer-column"},
                    {title: 'Client Number', slot: 'dealerMobile',width:130, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Client'), h('p', 'Number')])}},
                    {title: 'Pickup Company', slot: 'newPickupParty',width:165, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Pickup'), h('p', 'Company')])}},
                    {title: 'Company No.', slot: 'newPickupParty_Mobile',width:130, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Company'), h('p', 'Number')])}},
                    {title: 'Original Pickup Company', slot: 'originalPickupParty', width:170, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Original'), h('p', 'Pickup Company')])}},
                    {title: 'Order Details', slot: 'size',width:165, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Order Details'), h('p', '(Size & Qty)')])}},
                    {title: 'Total Wt.', slot: 'weight',width:100, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Total'), h('p', 'Weight')])}},
                    {title: 'Tempo No.', slot: 'tempo_platNo', width:165,className: "table-orderNum-column"},
                    {title: 'Tempo Contractor', slot: 'tempo_contractor',width:165, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Tempo'), h('p', 'Contractor')])}},
                    {title: 'Truck No.', slot: 'truck_platNo', width:165,className: "table-orderNum-column"},
                    {title: 'Transporter Name', slot: 'truck_transporter',width:165, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Transporter'), h('p', 'Name')])}},
                    {title: 'Note', slot: 'note',width:165, className: "table-orderNum-column"},
                    // {title: 'Dropping Party', slot: 'droppingParty', className: "table-orderNum-column",
                    //     renderHeader: function (h) {return h('div', [h('p', 'Dropping'), h('p', 'Party')])}},

                ],
                companyType: [],
                filter_pickUpDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                pickupPartyName: '',
                pickupPartyId: '',
                priority: [0, 1, 2],
                priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
                dealerCity: '',
                pickupCity: '',
                droppingCity: '',
                skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
                dealerCityFilter: '%%',
                pickupCityFilter: '%%',
                droppingCityFilter: '%%',
                selectedDealerCity: {"address":[]},
                selectedPickupCity: {"address":[]},
                selectedDroppingCity: {"address":[]},
                companyDetailDrawer: false,
                companyId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                search: '',
                manageOrderDrawer: false,
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                selected_totalWeight: 0
            }
        },
        computed: {
            searchFilter () {
                return '%' + this.globalSearch + '%'
            },
            lrName(){
                return { lrName: this.globalSearch }
            }
          // pickupPartyFilter() {
          //       return '%' + this.pickupPartyName + '%'
          //  }
        },
        methods: {
            onChangeDate(evt){
              this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
              this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            onSearchCity(event, str){
                if(str === 'clientCity'){
                    this.dealerCityFilter = '%' + this.dealerCity + '%';
                    this.skip.dealerSkip = false;
                }else if(str === 'pickupCity'){
                    this.pickupCityFilter = '%' + this.pickupCity + '%';
                    this.skip.pickupSkip = false;
                }else if(str === 'dropCity'){
                    this.droppingCityFilter = '%' + this.droppingCity + '%';
                    this.skip.dropSkip = false;
                }
            },
            onSelectCity(city, str){
                if(str === 'clientCity'){
                    this.selectedDealerCity = {"address":[{"city": city}]};
                }else if(str === 'pickupCity'){
                    this.selectedPickupCity = {"address":[{"city": city}]};
                }else if(str === 'dropCity'){
                    this.selectedDroppingCity = {"address":[{"city": city}]};
                }
            },
            onClearCity(str){
                if(str === 'clientCity'){
                    this.selectedDealerCity = {"address":[]};
                }else if(str === 'pickupCity'){
                    this.selectedPickupCity = {"address":[]};
                }else if(str === 'dropCity'){
                    this.selectedDroppingCity = {"address":[]};
                }
            },
            formatDate(date){
                return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            },
            openOrderDetail(rowData, rowindex) {
                this.orderId = rowData.id
                this.$refs['order-detail-page'].$apollo.queries.orders.skip = false
                this.orderDetailDrawer = true
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                this.currentOrderStatus = order.internalStatus.id;
                this.manageOrderDrawer = true;
            },
            onSelectionChangeOrder(arrList){
                if(arrList.length > 1){
                    let sum = arrList.reduce((a,b) => ({materials:{ kg: parseInt(a.materials.kg) + parseInt(b.materials.kg)}}))
                    this.selected_totalWeight = sum.materials.kg
                }else if(arrList.length === 1){
                    this.selected_totalWeight = arrList[0].materials.kg
                }else if(arrList.length === 0){
                    this.selected_totalWeight = 0
                }
                this.$emit('totalWeightOfSelectedOrders', this.selected_totalWeight)
            },
            startAddingOrder() {
                this.$refs['place-order-form'].skip = {dealerSkip: false, pickupSkip: false, dropSkip: false};
                this.placeOrderDrawer = true;
            },
            openCompanyDetail(companyId){
                this.companyId = companyId;
                this.$refs['company-detail-page'].skip = false;
                this.companyDetailDrawer = true;
            }
  /*        assignCompanyId(companyObj){
                this.pickupPartyId = companyObj.id;
            },
            onClearPickupParty(){
                this.pickupPartyId = ''
            }              */
        },
    mounted(){
            document.querySelector("#client_city").setAttribute("autocomplete", "new-password");
            document.querySelector("#pickup_city").setAttribute("autocomplete", "new-password");
            document.querySelector("#drop_city").setAttribute("autocomplete", "new-password");
        }
    }
</script>

<style scoped>
    /deep/ .ivu-dropdown-item{
        padding: 0px 0px;
    }
   /deep/ .ivu-dropdown-item-div{
        padding: 7px 16px;
        width: 100%;
    }
    /deep/ .ivu-table-wrapper, .ivu-table, .ivu-table-body {
        cursor: pointer !important;
    }
    .demo-drawer-prime {
        height: calc(100% - 55px);
        overflow: auto;
        paddingBottom: 53px;
        position: static;
    }
    /deep/ .ivu-table td.table-orderNum-column{
        font-size: 14px;
    }
    /deep/ .ivu-table td.table-dealer-column{
        font-size: 14px;
    }
    /deep/ .ivu-table td.table-dealer-column div.ivu-table-cell:hover{
        background: white;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }

</style>

